import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { IAssignment } from '../models/assignment';
import { AssignmentService } from '../services/assignment.service';
import { AssignmentStorageService } from '../storage/assignment-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentResolver  {
  constructor(
    private assignmentService: AssignmentService,
    private assignmentStore: AssignmentStorageService
    ){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const id = route.params.id;
    this.assignmentStore.getAssignment(id);

    return of(true);
  }
}
